import { createVNode as r, mergeProps as n } from "vue";
import i from "../node_modules/@pf-ui/pf-icon-svg/es/asn/PatientMaleTwotoneStandard.js";
import d from "../components/PfIcon.js";
const t = (e, a) => {
  const o = {
    ...e,
    ...a.attrs
  };
  return r(d, n(o, {
    icon: i
  }), null);
};
t.displayName = "PatientMaleTwotoneStandard";
t.inheritAttrs = !1;
export {
  t as default
};
